import {getDocumentUploadModalIcon, renderFormField} from '@common'
import {TranslationKey} from '@enums'
import SearchIcon from '@mui/icons-material/Search'
import {Grid, Stack, Typography} from '@mui/material'

import {UIKit} from '@components'

import {useCustomerFormModel} from './customer-form-model'
import {ButtonWrapper, CustomButton, ModalContentWrapper} from './style'

/**
 * Customer step
 */
export function CustomerForm() {
  const {
    customerFormFields,
    personalNumberFormField,
    isSearchBtnDisabled,
    isSearchBtnVisible,
    isUploadDocumentBtnVisibe,
    isDocumentUploadBtnDisabled,
    isQuote,
    onGetPersonDataBtnClick,
    isDocumentCheckModalOpen,
    doesDataMatch,
    onDocumentCheckModalClose,
    onUploadDocument,
    t,
  } = useCustomerFormModel()

  return (
    <>
      <UIKit.BackgroundCard title={t(TranslationKey['Customer information'])}>
        <Stack gap={2}>
          {!isQuote && (
            <Grid container spacing={2}>
              <Grid key={`customer-personal-no-form-field`} item sm={3}>
                {renderFormField(personalNumberFormField)}
              </Grid>

              {isSearchBtnVisible && (
                <ButtonWrapper key={`customer-personal-no-button`} item sm={3}>
                  <CustomButton
                    disabled={isSearchBtnDisabled}
                    endIcon={<SearchIcon />}
                    variant="contained"
                    onClick={onGetPersonDataBtnClick}
                  >
                    {t(TranslationKey['Get person data'])}
                  </CustomButton>
                </ButtonWrapper>
              )}
              {isUploadDocumentBtnVisibe && (
                <ButtonWrapper key={`document-upload-button`} item sm={3}>
                  <UIKit.ButtonDropzone disabled={isDocumentUploadBtnDisabled} handleDrop={onUploadDocument} />
                </ButtonWrapper>
              )}
            </Grid>
          )}

          <Grid container spacing={2}>
            {customerFormFields.map((item, index) => (
              <Grid key={`customer-form-field-${index}`} item sm={3}>
                {renderFormField(item)}
              </Grid>
            ))}
          </Grid>
        </Stack>
      </UIKit.BackgroundCard>

      <UIKit.Modal
        confirmButtonProps={{
          buttonText: t(TranslationKey.Close),
          onClick: onDocumentCheckModalClose,
        }}
        content={
          <ModalContentWrapper>
            {getDocumentUploadModalIcon(doesDataMatch)}
            <Typography textAlign={'justify'}>
              {t(
                TranslationKey[
                  doesDataMatch
                    ? 'The data on the document matches the provided customer information.'
                    : 'The data on the document does not match the provided customer information.'
                ],
              )}
            </Typography>
          </ModalContentWrapper>
        }
        open={isDocumentCheckModalOpen}
        title={t(TranslationKey['Document data match'])}
      />
    </>
  )
}
